var map = {
	"./content-deco-1.webp": 1465,
	"./content-deco-2.webp": 1466,
	"./deposit-icon.webp": 1467,
	"./home-icon-active.webp": 1468,
	"./home-icon.webp": 1469,
	"./live-icon-active.webp": 1470,
	"./live-icon.webp": 1471,
	"./me-icon-active.webp": 1472,
	"./me-icon.webp": 1473,
	"./product-overview-bg.webp": 1474,
	"./promos-icon-active.webp": 1475,
	"./promos-icon.webp": 1476,
	"./services-bg.webp": 1477,
	"./sponsor-icon-active.webp": 1478,
	"./sponsor-icon.webp": 1479,
	"./vip-icon.webp": 1480,
	"./withdraw-icon.webp": 1481,
	"./wwr-img.webp": 1482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;